// extracted by mini-css-extract-plugin
export var accordionToggles = "unified-search-module--accordionToggles--2f944";
export var dark = "unified-search-module--dark--b0f64";
export var filterAccordion = "unified-search-module--filterAccordion--4d1f3";
export var resourceMenu = "unified-search-module--resourceMenu--68fa7";
export var resultToggleBar = "unified-search-module--resultToggleBar--a8a13";
export var toggleButton = "unified-search-module--toggleButton--bcf6c";